var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container examination" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("订单审核")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c("form-filed", {
            ref: "formAttr",
            staticClass: "search-form",
            attrs: {
              formconfig: _vm.searchFormConfig.formconfig,
              formData: _vm.searchFormConfig.formData,
            },
            on: { formDataval: _vm.dialogClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "h3",
            [
              _vm._v("列表数据"),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.showDialog(
                        "批量审核",
                        "640px",
                        "shenheList",
                        _vm.multipleSelection,
                        true
                      )
                    },
                  },
                },
                [_vm._v("批量审核")]
              ),
            ],
            1
          ),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
            on: {
              onTableShowDialogCom: _vm.resTableShowDialog,
              tableSelectionChange: _vm.handleSelectionChange,
            },
          }),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "shenheList"
            ? [
                _c("audit-operation", {
                  ref: "shenheList",
                  attrs: {
                    orderObj: _vm.dialog.row,
                    dialogType: _vm.dialog.type,
                    afterNos: _vm.multipleSelection,
                    isBatch: _vm.dialog.batch,
                    isCleanUp: true,
                  },
                  on: { submitState: _vm.shenheState },
                }),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        attrs: { type: "primary", plain: "" },
                        on: { click: _vm.closeDialog },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.actionDialog },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type === "shenheStep"
            ? [
                _c("step-progress", {
                  attrs: {
                    orderObj: _vm.dialog.row,
                    processFunc: _vm.dictionaries.process_func,
                    type: "shenheStep",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }